import type { IOrganisation } from 'src/types/nya/common';

/**
 * Id:t på "organisationen" Privatperson. Det är en attrapp — ingen rad i
 * organisationstabellen, inte ens ett UUID — och finns bara för att
 * organisationsväljaren ska kunna visa ett läge utan förening.
 *
 * Därför får det aldrig nå backend: hamnar det i en org-scopad URL misslyckas
 * UUID-bindningen, och skickas det som `X-Organisation-Id` avvisas det. Av det
 * skälet lämnar {@link useAppContext} ut `organisation: undefined` i det här
 * läget — se `app-context-provider.tsx`. Behöver du veta vad användaren
 * faktiskt valt (namn, typ) finns `valdOrganisation` och `ärPrivatperson`.
 */
export const PRIVATPERSON_ID = 'privatperson';

export const PRIVATPERSON_ORG: IOrganisation = {
  id: PRIVATPERSON_ID,
  organisationsNamn: 'Privatperson',
  organisationsNummer: 'Enbart privatperson',
  momsregisteringsnummer: '',
  organisationsTyp: 'PRIVATPERSON',
  adress: {
    gata: '',
    nr: '',
    våning: '',
    postNummer: '',
    ort: '',
    fullständigAdress: null,
  },
  räkenskapsår: [],
};

export function ärPrivatpersonsId(orgId?: string | null): boolean {
  return orgId === PRIVATPERSON_ID;
}
